import { CaretRight } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface RowDetailsButtonProps {
	onClick: () => void;
}

export function RowDetailsButton({ onClick }: RowDetailsButtonProps) {
	const { t } = useTranslation();
	return (
		<Button
			variant="ghost"
			size="icon"
			aria-label={t("common.details")}
			onClick={(e) => {
				e.stopPropagation();
				onClick();
			}}
		>
			<CaretRight className="size-4" />
		</Button>
	);
}
